<div ngbDropdown container="body">
  <i class="fas me-2" [ngClass]="icon" [ngbTooltip]="note" *ngIf="category"></i>
  <a ngbDropdownToggle aria-expanded="false" aria-haspopup="true" href="javascript:;">
    {{ address | shortAddress }}
  </a>
  <div aria-labelledby="navbarDropdown" class="dropdown-menu dropdown-menu-dark dropdown-menu-fadein bg-secondary" ngbDropdownMenu>
    <a ngbDropdownItem class="dropdown-item d-flex align-items-center" [href]="ethWalletService.getAddressUrl(address)" target="_blank" rel="noopener">
      Open in Explorer
    </a>
    <a ngbDropdownItem class="dropdown-item d-flex align-items-center" [href]="'https://debank.com/profile/' + address" target="_blank" rel="noopener">
      Open in DeBank
    </a>
    <a ngbDropdownItem class="dropdown-item d-flex align-items-center" [routerLink]="['/monitor/accounts', address]">
      Detail
    </a>
    <a ngbDropdownItem class="dropdown-item d-flex align-items-center" [routerLink]="['/monitor/accounts', address, 'edit']">
      Edit
    </a>
    <a ngbDropdownItem class="dropdown-item d-flex align-items-center" href="javascript:;" (click)="observe()">
      Observe
    </a>
    <a ngbDropdownItem class="dropdown-item d-flex align-items-center" href="javascript:;" ngxClipboard [cbContent]="address" (click)="onClick()">
      Copy Address
    </a>
  </div>
</div>
